export const GA_ID = 'UA-170826174-2';
export const STRIPE_API_KEY = 'pk_live_51HEYLpLyY1lmZM1FermehCfuo1oZbBRivtQfNOQ0e80GWlsqzretVYR3TmwiBC2dRmKbPifyypLrAf1BTxNLIJMQ005e2U1JwZ';
export const PIXEL_ID = '289390839020419';
